module.exports = __webpack_public_path__ + "ad31bfd5f279b6b5611f5e0fae624f23.svg";